export default __webpack_public_path__ + "static/media/carrot-solid.5ce26a6b.svg";